import * as types   from "../../constants/action-types";

let initialState = {
    Refresh:false,
    Categories: [],
    User: {},
    AutoCompleteResults: false,
    ManufactureresResults:[],
    CarsResults:false,
    SearchResults:false,
    Car:false,
    LeadStatus:0,
    ValidSMS: false,
    OrderDetails:false,
    ContentPage:false,
    Favorites:false,
    CG:false,
    Appointments:false,
    SMS:false,
    Summary:false,
    Tags: false,
    ResultsFilters:false,
};

export default function data_reducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_RESULTS_FILTERS:
            return{
                ...state,
                ResultsFilters: action.payload
            };
        case types.SET_META_TAGS:
            return{
                ...state,
                Tags: action.payload
            };
        case types.SET_SUMMARY:
            return{
                ...state,
                Summary: action.payload
            };
        case types.SET_SMS:
            return{
                ...state,
                SMS: action.payload
            };
        case types.SET_APPOINTMENTS:
            return{
                ...state,
                Appointments: action.payload
            };
        case types.SET_CG:
            return{
                ...state,
                CG: action.payload
            };
        case types.SET_FAVORITES: {
            return {
                ...state,
                Favorites: action.payload
            };
        }
        case types.SET_CONTENT_PAGE:
            return{
                ...state,
                ContentPage: action.payload
            };
        case types.SET_ORDER_DETAILS:
            return{
                ...state,
                OrderDetails: action.payload
            };
        case types.SET_CATEGORIES:
            return {
                ...state,
                Categories: action.payload
            };
        case types.SET_USER:
            return {
                ...state,
                User: action.payload
            };
        case types.SET_AUTOCOMPLETE_RESULTS:
            return{
                ...state,
                AutoCompleteResults: action.payload
            };
        case types.SET_MANUFACTURERS: {
            return {
                ...state,
                ManufactureresResults: action.payload
            };
        }
        case types.SET_CARS: {
            if (!state.Refresh)
                return {
                    ...state,
                    CarsResults: [
                        ...state.CarsResults,
                        ...action.payload
                    ]
                };
            else
                return{
                    ...state,
                    CarsResults: action.payload
                };
        }
        case types.SET_SEARCH:
            return{
                ...state,
                SearchResults: action.payload
            };
        case types.SET_REFRESH:
            return{
                ...state,
                Refresh: action.payload
            };
        case types.SET_CAR:
            return{
                ...state,
                Car: action.payload
            };
        case types.GET_LEAD:
            return {
                ...state,
                LeadStatus: action.payload
            };
        case types.GET_SMS_VALIDATION:
            return{
                ...state,
                ValidSMS: action.payload
            };
        default:
            return state;
    }
}
